import React from "react"
import omit from "lodash/omit"
import isEqual from "lodash/isEqual"

import { Grid } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import { useFiltersConfiguration } from "entities/user-settings"

const AppliedFiltersContext = React.createContext({
  defaultFilters: [],
  configKey: null
})

export const useAppliedFiltersContext = () =>
  React.useContext(AppliedFiltersContext)

export const AppliedFiltersContainer = ({
  filters,
  initialFilters,
  configKey = null,
  children,
  defaultFilters = []
}) => {
  const configuration = useFiltersConfiguration(configKey, defaultFilters)
  const theme = useTheme()

  const hideFilterChips = isEqual(
    omit(initialFilters, configuration),
    omit(filters, configuration)
  )
  if (hideFilterChips) {
    return null
  }

  return (
    <AppliedFiltersContext.Provider value={{ defaultFilters, configKey }}>
      <Grid
        container
        gap={1}
        data-testid="applied-filters"
        alignItems="center"
        sx={{
          [theme.breakpoints.down("md")]: {
            flexWrap: "nowrap",
            overflowX: "scroll"
          },
          pb: 0,
          "& > .MuiGrid-item": { p: 0 }
        }}
      >
        {children}
      </Grid>
    </AppliedFiltersContext.Provider>
  )
}
